import { Component, AfterViewInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DxDataGridComponent } from 'devextreme-angular';
import { DataService } from '../core/data.service';
import { ActiveModal } from '../shared/modal/modal.service';


@Component({
  selector: 'app-recurrent-loadingitem-form',
  templateUrl: 'recurrent-loadingitem-form.component.html',
  styleUrls: ['recurrent-loadingitem-form.component.css']
})
export class RecurrentLoadingItemFormComponent implements AfterViewInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  products = [];
  @Output() addedItem = new EventEmitter();
  quantity;
  selectedProduct;
  constructor(
    private notificationsService: NotificationsService,
    private dataService: DataService,
    private activeModal: ActiveModal
  ) { }

  ngAfterViewInit() {
    this.dataGrid.instance.option({
      filterRow: { visible: true },
      hoverStateEnabled: true,
      onSelectionChanged: this.onGridSelectionChanged.bind(this),
      selection: { mode: 'single' },
      showBorders: false
    });

    this.dataService.getProducts().then(products => {
      this.products = products;
    });
  }
  onGridSelectionChanged(e) {
    this.selectedProduct = e.selectedRowsData[0];
  }
  addPrduct() {
    if (this.selectedProduct == null ) {
      this.notificationsService.error('Missing Value', 'Select the Product.');
      return;
    }
    this.addedItem.emit({
      productID: this.selectedProduct.id,
      product: this.selectedProduct,
      qty: this.quantity,
      loadNumber: null,
      deleted: false,
      extNr1: null,
      extNr2: null,
      id: 0,
      pos: 0,
      loadingTemplateID: 0,
      changeDate: null
    });
    this.activeModal.dismiss();
  }
  cancel() {
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-loadingitem-form.component.ts